// @tennis-matches/services/winterdoppel/rahmenplanDefaults

export const WINTERDOPPEL_RAHMENPLAN_LEVELS = Object.freeze([
  "sicher",
  "teilweise",
  "noch_nicht",
]);

export const WINTERDOPPEL_RAHMENPLAN_DEFAULT_CONTENT_ROWS = Object.freeze([
  { focusKey: "schwerpunkt", label: "Schwerpunkt", sortOrder: 10 },
  { focusKey: "technik_taktik", label: "Technik / Taktik", sortOrder: 20 },
  { focusKey: "spielform", label: "Spielform / Beobachtung", sortOrder: 30 },
]);

export const WINTERDOPPEL_RAHMENPLAN_DEFAULT_ASSESSMENT_ROWS = Object.freeze([
  {
    focusKey: "ballwechsel",
    label: "Ballwechselstabilität",
    sortOrder: 100,
  },
  {
    focusKey: "aufschlag_return",
    label: "Aufschlag / Return",
    sortOrder: 110,
  },
  { focusKey: "bewegung", label: "Bewegung", sortOrder: 120 },
  {
    focusKey: "taktik_entscheidung",
    label: "Taktische Entscheidungen",
    sortOrder: 130,
  },
  {
    focusKey: "wettkampfverhalten",
    label: "Wettkampfverhalten / Selbstständigkeit",
    sortOrder: 140,
  },
]);

const FOCUS_KEYS = ["schwerpunkt", "technik_taktik", "spielform"];

/** U12 Medenspiel: Session-Reihenfolge (ohne Kalenderdatum) */
export const WINTERDOPPEL_U12_MEDENSPIEL_SESSIONS = Object.freeze([
  {
    month: 10,
    schwerpunkt: "Standortbestimmung",
    technik_taktik: "VH/RH, Aufschlag, Return, Bewegung",
    spielform: "Viele Punkte spielen; Ausgangsniveau jedes Spielers festhalten",
  },
  {
    month: 10,
    schwerpunkt: "Ballkontrolle",
    technik_taktik: "Länge, Höhe, Sicherheit; Cross als Grundmuster",
    spielform: "Wer schafft stabile Ballwechsel?",
  },
  {
    month: 10,
    schwerpunkt: "Cross-Spiel",
    technik_taktik: "VH/RH Cross, Winkel, Platz öffnen",
    spielform: "Crossduelle, anschließend Punkt frei",
  },
  {
    month: 11,
    schwerpunkt: "Longline & Richtungswechsel",
    technik_taktik: "Wann darf ich aus Cross longline wechseln?",
    spielform: "Punktaufbau: erst Cross, dann bewusst öffnen",
  },
  {
    month: 11,
    schwerpunkt: "Aufschlag I",
    technik_taktik: "Rhythmus, Treffpunkt, sicherer 1./2. Aufschlag",
    spielform: "Aufschlag + erster Ball",
  },
  {
    month: 11,
    schwerpunkt: "Return",
    technik_taktik: "kompakte Bewegung, Returnrichtung, neutralisieren",
    spielform: "Return + erster Grundschlag",
  },
  {
    month: 12,
    schwerpunkt: "Bewegen & Positionieren",
    technik_taktik: "Split Step, zum Ball – vom Ball, Recovery",
    spielform: "Punkte mit Fokus auf Stellung nach dem Schlag",
  },
  {
    month: 12,
    schwerpunkt: "Angriff",
    technik_taktik: "kurzer Ball erkennen, nach vorne spielen",
    spielform: "Kurzer Ball → Angriff → Punkt ausspielen",
  },
  {
    month: 12,
    schwerpunkt: "Netzspiel",
    technik_taktik: "Volley, Position, Übergang ans Netz",
    spielform: "Angriff + Volley; Doppelgrundlagen",
  },
  {
    month: 1,
    schwerpunkt: "Matchtaktik I",
    technik_taktik: "eigene Stärke einsetzen, Schwäche Gegner erkennen",
    spielform: "Tie-Breaks / kurze Sätze",
  },
  {
    month: 1,
    schwerpunkt: "Matchtaktik II",
    technik_taktik: "Aufschlagspiel/Returnspiel; Spielstand beachten",
    spielform: "echte Matchsituationen, Coaching nur zwischen Spielen",
  },
  {
    month: 1,
    schwerpunkt: "MEDENSPIEL-CHECK",
    technik_taktik: "keine neue Technik",
    spielform:
      "Einzel + Doppel möglichst wettkampfnah → Entscheidung für Meldung",
  },
  {
    month: 2,
    schwerpunkt: "Aufschlag + Return",
    technik_taktik: "Beginn des Punktes verbessern",
    spielform: "Serve +1 / Return +1",
  },
  {
    month: 2,
    schwerpunkt: "Defensive",
    technik_taktik: "hoher/tiefer Ball, Zeit gewinnen",
    spielform: "Von Defensive zurück in neutrale Position",
  },
  {
    month: 2,
    schwerpunkt: "Offensive",
    technik_taktik: "Platz öffnen, freien Raum nutzen",
    spielform: "2–3-Schlag-Kombinationen",
  },
  {
    month: 2,
    schwerpunkt: "Doppel I",
    technik_taktik: "Grundposition, Netzspieler, Kommunikation",
    spielform: "viele Doppel-Tie-Breaks",
  },
  {
    month: 3,
    schwerpunkt: "Doppel II",
    technik_taktik: "Aufschlag/Return im Doppel, Bewegung",
    spielform: "komplette Doppel",
  },
  {
    month: 3,
    schwerpunkt: "Matchtraining",
    technik_taktik: "Spielstand, Entscheidungen, Selbstständigkeit",
    spielform: "Satzspiele",
  },
  {
    month: 4,
    schwerpunkt: "Generalprobe",
    technik_taktik: "Einzel + Doppel",
    spielform: "„Medenspieltag“ simulieren",
  },
  {
    month: 4,
    schwerpunkt: "Individuelle Baustellen",
    technik_taktik: "pro Spieler 1–2 Themen",
    spielform: "Abschlusstest / Match",
  },
]);

/** @deprecated Legacy MM-DD-Map – aus Sessions abgeleitet */
export const WINTERDOPPEL_U12_MEDENSPIEL_CELLS = Object.freeze(
  Object.fromEntries(
    WINTERDOPPEL_U12_MEDENSPIEL_SESSIONS.map((s, i) => {
      const md = `${String(s.month).padStart(2, "0")}-${String(i + 1).padStart(2, "0")}`;
      const cell = {};
      for (const k of FOCUS_KEYS) if (s[k]) cell[k] = s[k];
      return [md, cell];
    }),
  ),
);

export const WINTERDOPPEL_U12_MEDENSPIEL_TEMPLATE =
  WINTERDOPPEL_U12_MEDENSPIEL_CELLS;

export const WINTERDOPPEL_U12_MEDENSPIEL_MILESTONE = Object.freeze({
  afterSession: 12,
  month: 1,
  day: 31,
  kind: "decision",
  label: "Meldeschluss – Entscheidung U12 Medenrunde",
  notes:
    "Sind die Spieler mannschafts- und wettkampffähig genug für die Medenspiel-Meldung?",
});

export const WINTERDOPPEL_RAHMENPLAN_TEMPLATES = Object.freeze([
  Object.freeze({
    id: "u12_medenspiel",
    labelKey: "winterdoppel.rahmenplan.template.u12_medenspiel",
    descriptionKey: "winterdoppel.rahmenplan.template.u12_medenspielDesc",
    sessions: WINTERDOPPEL_U12_MEDENSPIEL_SESSIONS,
    milestone: WINTERDOPPEL_U12_MEDENSPIEL_MILESTONE,
  }),
]);

export function listWinterDoppelRahmenplanTemplates() {
  return WINTERDOPPEL_RAHMENPLAN_TEMPLATES;
}

export function getWinterDoppelRahmenplanTemplate(templateId) {
  const id = String(templateId || "").trim();
  return WINTERDOPPEL_RAHMENPLAN_TEMPLATES.find((t) => t.id === id) || null;
}

export function winterDoppelSessionMonthDay(sessionDate) {
  const iso = String(sessionDate || "").slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(iso)) return "";
  return iso.slice(5);
}

/** Zellen einer Vorlagen-Session (1-basiert Index) */
export function resolveRahmenplanTemplateSessionCells(template, sessionIndex0) {
  const list = Array.isArray(template?.sessions) ? template.sessions : null;
  if (!list || sessionIndex0 < 0 || sessionIndex0 >= list.length) return null;
  const s = list[sessionIndex0];
  if (!s) return null;
  const cell = {};
  for (const k of FOCUS_KEYS) {
    if (s[k]) cell[k] = s[k];
  }
  return Object.keys(cell).length ? cell : null;
}

/** @deprecated Datum-Match – Vorlagen nutzen Session-Index */
export function resolveRahmenplanTemplateCellsForSessionDate(
  template,
  sessionDate,
) {
  void sessionDate;
  return null;
}

export function resolveU12TemplateForSessionDate(sessionDate) {
  void sessionDate;
  return null;
}
